import React from 'react';

import { useAuthDataContext } from 'components/AuthDataProvider/AuthDataProvider';

import MyBrokeragePage from 'views/BrokerageAdmin/MyBrokeragePage';
import AdminDashboardPage from 'views/Dashboard/AdminDashboardPage';
import CampaignDashboardPage from 'views/Dashboard/CampaignDashboardPage';

const DashboardPageWrapper = () => {
  const { isAdmin, isBrokerageAdmin } = useAuthDataContext();

  if (isAdmin) {
    return <AdminDashboardPage />;
  }

  if (isBrokerageAdmin) {
    return <MyBrokeragePage />;
  }

  return <CampaignDashboardPage />;
};

export default DashboardPageWrapper;
